import { INavPreviewCol } from "@models/nav.interface";
import { ProductSlug } from "@models/pages/product-page.interface";

interface IProductsPreviewState {
  columns: INavPreviewCol[];
}

export const ProductsPreviewState: IProductsPreviewState = {
  columns: [
    {
      cards: [
        {
          title: 'Products.Nav.OnRamp.Title',
          subtitle: 'Products.Nav.OnRamp.Subtitle',
          iconSrc: '/layout-images/header/products-preview/arrow-down-outline.svg',
          href: `/products/${ProductSlug.ON_RAMP}`,
        },
        {
          title: 'Products.Nav.OffRamp.Title',
          subtitle: 'Products.Nav.OffRamp.Subtitle',
          iconSrc: '/layout-images/header/products-preview/arrow-up-outline.svg',
          href: `/products/${ProductSlug.OFF_RAMP}`,
        },
        {
          title: 'Products.Nav.OnOffRamp.Title',
          subtitle: 'Products.Nav.OnOffRamp.Subtitle',
          iconSrc: '/layout-images/header/products-preview/grid-plus.svg',
          href: `/products/${ProductSlug.CORPORATE_ON_OFF_RAMP}`,
        },
        {
          title: 'Products.Nav.AcceptCrypto.Title',
          subtitle: 'Products.Nav.AcceptCrypto.Subtitle',
          iconSrc: '/layout-images/header/products-preview/cart.svg',
          href: `/products/${ProductSlug.ACCEPT_CRYPTO}`,
        },
      ],
    },
    {
      cards: [
        {
          title: 'Products.Nav.OnlinePayment.Title',
          subtitle: 'Products.Nav.OnlinePayment.Subtitle',
          iconSrc: '/layout-images/header/products-preview/lock.svg',
          href: `/products/${ProductSlug.ACCEPT_PAYMENTS}`,
        },
        {
          title: 'Products.Nav.Retail.Title',
          subtitle: 'Products.Nav.Retail.Subtitle',
          iconSrc: '/layout-images/header/products-preview/store.svg',
          href: `/products/${ProductSlug.POS}`,
        },
        {
          title: 'Products.Nav.CryptoPayroll.Title',
          subtitle: 'Products.Nav.CryptoPayroll.Subtitle',
          iconSrc: '/layout-images/header/products-preview/users-group.svg',
          href: `/products/${ProductSlug.CRYPTO_PAYROLL}`,
        },
      ],
    },
  ],
};
